import React from 'react';
import PropTypes from 'prop-types';
import {useSelector} from 'react-redux';

import {numberFormatsListItems} from '../../../util/uiconstants';
import {numberFormattedText} from '@ey/utils';

import OutputText from '@ey/canvascoreservices/OutputText';

import Badge from '../../CoreWrappers/Badge';
import StyledCountDisplay from './StyledCountDisplay';

const CountDisplayV2 = ({count = null, label = null, singleLabel = null, className = null}) => {
	const numberFormat = useSelector(({userPreferences}) => userPreferences.numberFormat);

	if (!count || !label) return false;

	const convertedNumberFormat = numberFormatsListItems.find(({label}) => label === numberFormat)?.id;
	const formattedCount = numberFormattedText(convertedNumberFormat !== undefined ? convertedNumberFormat : 0, count);

	let displayLabel = label;
	if (singleLabel) displayLabel = count === 1 ? singleLabel : label;
	let displayTitle = `${formattedCount} ${displayLabel}`;

	const renderBadge = () => {
		const props = {
			variant: 'default',
			value: count
		};

		return <Badge {...props} />;
	};

	const renderLabel = () => (
		<OutputText light ellipsis title={displayTitle}>
			{displayLabel}
		</OutputText>
	);

	const props = {
		title: displayTitle
	};

	if (className) props.className = className;

	return (
		<StyledCountDisplay {...props}>
			{renderBadge()}
			{renderLabel()}
		</StyledCountDisplay>
	);
};

CountDisplayV2.propTypes = {
	count: PropTypes.number.isRequired,
	label: PropTypes.string.isRequired,
	singleLabel: PropTypes.string,
	className: PropTypes.string
};

export default CountDisplayV2;
